import questionData from "./data/questions";
import imageData from "./data/images";

export const getQuestion = (question) => {
  return questionData[question];
};

export const getImage = (image) => {
  return imageData[image];
};

export const categories = () => {
  return Object.values(questionData)
    .reduce(
      (unique, question) =>
        unique.includes(question.category)
          ? unique
          : [...unique, question.category],
      []
    )
    .filter((i) => i);
};

export const categoriesFromList = (questionsList) => {
  return questionsList.map(q => getQuestion(q))
    .reduce(
      (unique, question) =>
        unique.includes(question.category)
          ? unique
          : [...unique, question.category],
      []
    )
    .filter((i) => i);
};

export const topics = (category) => {
  return Object.values(questionData)
    .filter((question) => (category ? question.category === category : true))
    .reduce(
      (unique, question) =>
        unique.includes(question.topic) ? unique : [...unique, question.topic],
      []
    )
    .filter((i) => i);
};

export const questions = (category, topic) => {
  return Object.fromEntries(
    Object.entries(questionData).filter(([key, question]) => {
      return (
        (category ? question.category === category : true) &&
        (topic ? question.topic === topic : true)
      );
    })
  );
};

export const questionsFromListByCategory = (questionsList) => {
  return questionsList.reduce((prev, current) =>{
    const category = questionData[current].category;
    const prevCategory = prev[category] || [];
    return {...prev, [category]: [...prevCategory, current] };
  }, {});
};

export const answeredQuestionsFromList = (answers, questionsList) => {
  return questionsList.filter((key) => {
    return Object.keys(answers).includes(key);
  });
};

export const answeredQuestionsFromListByCategory = (answers, questionsList) => {
  return answeredQuestionsFromList(answers, questionsList).reduce((prev, current) =>{
    const category = questionData[current].category;
    const prevCategory = prev[category] || [];
    return {...prev, [category]: [...prevCategory, current] };
  }, {});
};

export const answeredQuestions = (answers, category, topic) => {
  let i = Object.keys(questions(category, topic));
  return answeredQuestionsFromList(answers, i);
};

export const unansweredQuestionsFromList = (answers, questionsList) => {
  return questionsList.filter((key) => {
    return !Object.keys(answers).includes(key);
  });
};

export const unansweredQuestionsFromListByCategory = (answers, questionsList) => {
  return unansweredQuestionsFromList(answers, questionsList).reduce((prev, current) =>{
    const category = questionData[current].category;
    const prevCategory = prev[category] || [];
    return {...prev, [category]: [...prevCategory, current] };
  }, {});
};

export const unansweredQuestions = (answers, category, topic) => {
  let i = Object.keys(questions(category, topic));
  return unansweredQuestionsFromList(answers, i);
};

export const correctQuestionsFromList = (answers, questionsList) => {
  return questionsList.filter((key) => {
    return (
      Object.keys(answers).includes(key) &&
      answers[key] === getQuestion(key).answer
    );
  });
};

export const correctQuestionsFromListByCategory = (answers, questionsList) => {
  return correctQuestionsFromList(answers, questionsList).reduce((prev, current) =>{
    const category = questionData[current].category;
    const prevCategory = prev[category] || [];
    return {...prev, [category]: [...prevCategory, current] };
  }, {});
};

export const correctQuestions = (answers, category, topic) => {
  let i = Object.keys(questions(category, topic));
  return correctQuestionsFromList(answers, i);
};

export const incorrectQuestionsFromList = (answers, questionsList) => {
  return questionsList.filter((key) => {
    return (
      Object.keys(answers).includes(key) &&
      answers[key] !== getQuestion(key).answer
    );
  });
};

export const incorrectQuestionsFromListByCategory = (answers, questionsList) => {
  return incorrectQuestionsFromList(answers, questionsList).reduce((prev, current) =>{
    const category = questionData[current].category;
    const prevCategory = prev[category] || [];
    return {...prev, [category]: [...prevCategory, current] };
  }, {});
};

export const incorrectQuestions = (answers, category, topic) => {
  let i = Object.keys(questions(category, topic));
  return incorrectQuestionsFromList(answers, i);
};
